import React, { useContext } from "react";
import { Popover } from "antd";
import { AiOutlineSchedule } from "react-icons/ai";
import { FaLock, FaArrowsAltH } from "react-icons/fa";
import { AppContext } from "../../../context";

function CurrentReservations({ reservation_time_ranges }) {
  const info = useContext(AppContext);

  return (
    <Popover
      content={
        <div>
          <div style={{ width: "100%", textAlign: "center" }}>
            <strong>{info.t("reservations")}</strong>
          </div>
          {reservation_time_ranges?.map(
            (r, index) =>
              r.startDateTime !== "" && (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    width: 400,
                    padding: 20,
                  }}
                  key={index}
                >
                  <FaLock style={{ marginRight: 10 }} />
                  <strong>{r.startDateTime.split(" ")[0]}</strong>{" "}
                  <span style={{ marginLeft: 10 }}>
                    {r.startDateTime.split(" ")[1].slice(0, 5)}
                  </span>
                  {"  "}
                  <FaArrowsAltH style={{ margin: "0 10px" }} />
                  {"  "}
                  {r.startDateTime.split(" ")[0] !==
                    r.endDateTime.split(" ")[0] && (
                    <strong style={{ marginRight: 10 }}>
                      {r.endDateTime.split(" ")[0]}
                    </strong>
                  )}{" "}
                  <span>{r.endDateTime.split(" ")[1].slice(0, 5)}</span>
                </div>
              )
          )}
        </div>
      }
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <AiOutlineSchedule size={30} />{" "}
        <strong style={{ marginLeft: 10 }}>{info.t("reservations")}</strong>
      </div>
    </Popover>
  );
}

export default CurrentReservations;
